import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungHagen() {
  return (
    <CityPageTemplate
      city="Hagen"
      slug="hagen"
      intro="Hagen im südlichen Ruhrgebiet – smarte Finanzberatung ohne Banktermin, direkt für Dich."
      description="Unabhängige & digitale Finanzberatung für Hagen: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
